import {
    NgModule,
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA,
} from "@angular/core";
import { RouterModule } from "@angular/router";
import { CommonModule } from "@angular/common";
import { FlexLayoutModule } from "@angular/flex-layout";

import { GlobalModule } from "../Global/Global.module";
import { ProductGridComponent } from "./Grid/ProductGrid/ProductGrid.component";
import { ReviewComponent } from "./Review/Review.component";
import { ShopDetailsComponent } from "./ShopDetails/ShopDetails.component";
import { NgxPaginationModule } from "ngx-pagination";
import { FormsModule } from "@angular/forms";
import { SizeChartsDialogComponent } from "./ShopDetails/size-charts-dialog/size-charts-dialog.component";
import { BreadCrumbsModule } from "../Global/components/bread-crumbs/bread-crumbs/bread-crumbs.module";
import { ShareDialogComponent } from "./share-dialog/share-dialog.component";
import { SwiperModule } from "swiper/angular";
import { SwiperConfigInterface, SWIPER_CONFIG } from "ngx-swiper-wrapper";
import { BarRatingModule } from "ngx-bar-rating";
import { LongDescriptionComponent } from './ShopDetails/long-description/long-description.component';

const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
    direction: "horizontal",
    slidesPerView: "auto",
};
@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        FlexLayoutModule,
        GlobalModule,
        FormsModule,
        SwiperModule,
        NgxPaginationModule,
        BreadCrumbsModule,
        BarRatingModule,

    ],
    declarations: [
        ProductGridComponent,
        ReviewComponent,
        ShopDetailsComponent,
        SizeChartsDialogComponent,
        ShareDialogComponent,
        LongDescriptionComponent,
    ],
    exports: [ProductGridComponent, ReviewComponent, ShopDetailsComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
    entryComponents: [SizeChartsDialogComponent],
    providers: [
        {
            provide: SWIPER_CONFIG,
            useValue: DEFAULT_SWIPER_CONFIG,
        },
    ],
})
export class TemplatesModule {}
